import { FC } from "react";
import { Link } from "react-router-dom";

type NotFoundPageProps = {
  lang?: string;
};

const NotFoundPage: FC<NotFoundPageProps> = ({ lang = "en" }) => {
  const isKorean = lang.toLowerCase().startsWith("ko");
  const homePath = `/${lang}`;

  return (
    <section
      style={{
        maxWidth: "720px",
        margin: "0 auto",
        padding: "96px 24px",
        textAlign: "center",
      }}
    >
      <p>404</p>
      <h1>{isKorean ? "페이지를 찾을 수 없습니다" : "Page not found"}</h1>
      <p>
        {isKorean
          ? "주소를 확인하거나 AUTOVID 홈으로 이동해 주세요."
          : "Check the address or return to the AUTOVID home page."}
      </p>
      <Link to={homePath}>{isKorean ? "홈으로 이동" : "Go to home"}</Link>
    </section>
  );
};

export default NotFoundPage;
